import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import PageTitle from "../../../../components/partials/PageTitle";
import * as yup from "yup";
import Select from "../../../../components/form/select/Select";
import { useDispatch } from "react-redux";
import {
  createClaimSettings,
  getCategoryPolicy,
  resetClaimStatus,
} from "../../../../redux/slice/claim/claimSlice";
import { useSelector } from "react-redux";
import { getSinglePolicyCover } from "../../../../redux/slice/policy/policySlice";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { getAllCovers } from "../../../../redux/slice/cover/coverSlice";
import AddCustomForm from "../../../../components/settings/AddCustomForm";

const policies = [
  { name: "General Policy", id: "1" },
  { name: "Savings Policy", id: "2" },
  { name: "Credit Life", id: "3" },
];

const claimsCategory = [
  { name: "Other Cover", id: "other_cover" },
  { name: "Savings Claim", id: "savings_claim" },
];

const claimsType = [
  { name: "Maturity", id: "1" },
  { name: "Termination", id: "2" },
  { name: "Partial Withdrawal", id: "3" },
  { name: "Death Benefit", id: "4" },
];
const AddConfiguration = () => {
  const { user } = useSelector((state) => state?.auth?.user);
  const { category_policy, createSuccess } = useSelector(
    (state) => state?.claim
  );
  const { single_policy_cover } = useSelector((state) => state?.policy);
  const { unpaginated_forms } = useSelector((state) => state.form);
  const { unpaginated_workflow } = useSelector((state) => state.workflow);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const { all_covers } = useSelector((state) => state?.cover);

  const [policyCoverChange, setPolicyCoverChange] = useState(false);
  const [hasCustomForm, setHasCustomForm] = useState(null)


  const policyCoverRef = useRef();

  // console.log(all_covers.unpaginated_cover);
  // console.log(single_policy_cover);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const breadcrumb = {
    from: {
      title: "Claim Configuration",
      link: "/admin/settings/claim-configuration",
    },
    current: {
      title: "Add",
      link: null,
    },
  };

  const onSubmit = (values) => {
    let payload;
    if (values.policy_category_id === '1') {
      payload = {
        name: values.name,
        policy_category_id: values.policy_category_id,
        policy_id: values.policy_id,
        form_id: values.form_id,
        workflow_id: values.workflow_id,
        policy_cover: values.policy_cover,
      }
    }else if (values.policy_category_id === '2') {
      if (values.claim_category === 'savings_claim') {
        payload = {
          name: values.name,
          policy_category_id: values.policy_category_id,
          policy_id: values.policy_id,
          form_id: values.form_id,
          workflow_id: values.workflow_id,
          claim_category: values.claim_category,
          claim_type: values.claim_type,
        } 
      }else{
        payload = {
          name: values.name,
          policy_category_id: values.policy_category_id,
          policy_id: values.policy_id,
          form_id: values.form_id,
          workflow_id: values.workflow_id,
          policy_cover: values.policy_cover,
          claim_category: values.claim_category,
        }
      }
    }
    dispatch(createClaimSettings(payload));
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    handleChange,
    setFieldValue,
    // setFieldError,
    // resetForm,
  } = useFormik({
    // enableReinitialize: true,
    initialValues: {
      name: "",
      policy_category_id: "",
      policy_id: "",
      policy_cover: "",
      form_id: "",
      workflow_id: "",
      claim_category: "",
      claim_type: "",
    },
    onSubmit,
    validationSchema: () =>
      yup.object().shape({
        name: yup.string().required("Name is required"),
        policy_category_id: yup
          .number()
          .required("Policy Category is required"),
        policy_id: yup.number().required("Policy is required"),
        // policy_cover: yup.string().required("Policy Cover is required"),
        // form_id: yup.number().required("Form is required"),
        workflow_id: yup.number().required("Workflow is required"),
      }),
    validate: (values) => {
      const errors = {};
      if (values.policy_category_id === "2") {
        errors.claim_category = "Claims Category is required";
      }
      if (values.policy_category_id === "1" || values.claim_category === "other_cover") {
        errors.policy_cover = "Policy Cover is required";
      }
      if (values.claim_category === "savings_claim" && values.policy_category_id === '2') {
        errors.claim_type = "Claims type is required";
      }
    }
  });

  const policyData = policies?.map((policy) => {
    return {
      label: policy.name,
      value: policy.id,
    };
  });
  // console.log(all_covers?.unpaginated_cover);
  const categoryData = category_policy?.map((policy) => {
    return {
      label: policy.name,
      value: policy.policy_id ? policy.policy_id : policy.id,
    };
  });
  const coverData =
    single_policy_cover &&
    all_covers?.unpaginated_cover
      ?.filter((cover) =>
        single_policy_cover?.some(
          (element) => String(element.cover) === String(cover.id)
        )
      )
      .map((item) => ({
        value: item.id,
        label: item.name,
      }));

  const formData = unpaginated_forms?.map((form) => {
    return {
      label: form.form_name,
      value: form.id,
    };
  });
  const workflowData = unpaginated_workflow?.map((form) => {
    return {
      label: form.work_flow_name,
      value: form.id,
    };
  });
  const claimsCategoryData = claimsCategory?.map((cat) => {
    return {
      label: cat.name,
      value: cat.id,
    };
  });
  const claimsTypeData = claimsType?.map((type) => {
    return {
      label: type.name,
      value: type.id,
    };
  });

  function findTargetRoleById(idToFind, workflowsArray) {
    // Loop through the workflowsArray to find the matching workflow by id
    for (let i = 0; i < workflowsArray?.length; i++) {
      if (workflowsArray[i].id === idToFind) {
        // Return the target_role of the matching workflow
        return workflowsArray[i].target_role;
      }
    }
    // If no matching workflow is found, return null or handle it as needed
    return null; // or return a default value
  }

  const targetRole = findTargetRoleById(
    values?.workflow_id,
    unpaginated_workflow
  );


  useEffect(() => {
    if (values?.policy_category_id) {
      dispatch(
        getCategoryPolicy({
          office_id: user?.office_id,
          policy_cat_id: values?.policy_category_id,
        })
      );
    }
  }, [dispatch, user?.office_id, values?.policy_category_id]);

  useEffect(() => {
    if (values?.policy_id && values?.policy_category_id === '1') {
      dispatch(getAllCovers());
      dispatch(getSinglePolicyCover({id:values?.policy_id}));
      if (policyCoverChange) {
        policyCoverRef?.current?.clearValue();
        setPolicyCoverChange(false);
      }
    }else if (values?.policy_id && values?.policy_category_id === '2' && values?.claim_category === 'other_cover' ) {
      dispatch(getAllCovers());
      dispatch(getSinglePolicyCover({id:values?.policy_id, claim_category: 'other_cover'}));
      if (policyCoverChange) {
        policyCoverRef?.current?.clearValue();
        setPolicyCoverChange(false);
      }
    }
  }, [dispatch, policyCoverChange, values?.claim_category, values?.policy_category_id, values?.policy_id]);

  useEffect(() => {
    if (createSuccess) {
      dispatch(resetClaimStatus());
      if (values.policy_category_id === '2') {        
        navigate("/admin/settings/savings-claim-configuration");
      }else if (values.policy_category_id === '1') {
        navigate("/admin/settings/claim-configuration");
      }
    }
  }, [createSuccess, dispatch, navigate, values.policy_category_id]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "claim configuration module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create claim configuration"
      )
    ) {
      navigate("/admin/dashboard");
    }


    setHasCustomForm(
      user_permissions?.some((permission) => permission.name === "custom form module") && user_permissions?.some((permission) => permission.name === "create custom form")
    );
  }, [navigate, user_permissions]);
  

  return (
    <div>
      {/* page title */}
      <PageTitle title='Add Claim Configuration' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <form onSubmit={handleSubmit}>
              <div className='row mb-2 mt-4'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Name <span className='text-danger'>*</span>
                  </label>
                </div>
                <div className='col-md-7 col-lg-6'>
                  <input
                    type='text'
                    name='name'
                    className='form-control form-control-sm'
                    id='name'
                    value={values?.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors?.name && touched?.name && (
                    <p className='mb-0 text-danger'>{errors?.name + "*"}</p>
                  )}
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy Category <span className='text-danger'>*</span>
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "policy_category_id" } });
                    }}
                    name='policy_category_id'
                    data={policyData}
                    value={values?.policy_category_id}
                    onChange={(selectedOption) =>
                      setFieldValue("policy_category_id", selectedOption?.value)
                    }
                  />
                  {errors?.policy_category_id &&
                    touched?.policy_category_id &&
                    !values?.policy_category_id && (
                      <p className='mb-0 text-danger'>
                        {errors?.policy_category_id + "*"}
                      </p>
                    )}
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy <span className='text-danger'>*</span>
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "policy_id" } });
                    }}
                    name='policy_id'
                    data={categoryData}
                    value={values?.policy_id}
                    onChange={(selectedOption) =>{
                      setFieldValue("policy_id", selectedOption?.value)
                      setPolicyCoverChange(true);
                    }}
                  />
                  {errors?.policy_id &&
                    touched?.policy_id &&
                    !values?.policy_id && (
                      <p className='mb-0 text-danger'>
                        {errors?.policy_id + "*"}
                      </p>
                    )}
                </div>
              </div>
              {values.policy_category_id === "2" && <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Claims Category <span className='text-danger'>*</span>
                  </label>
                </div>
                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "claim_category" } });
                    }}
                    name='claim_category'
                    data={claimsCategoryData}
                    value={values?.claim_category}
                    onChange={(selectedOption) =>
                      setFieldValue("claim_category", selectedOption?.value)
                    }
                  />
                  {errors?.claim_category &&
                    touched?.claim_category &&
                    !values?.claim_category && (
                      <p className='mb-0 text-danger'>
                        {errors?.claim_category + "*"}
                      </p>
                    )}
                </div>
              </div>}
              {(values.policy_category_id === "1" || values.claim_category === "other_cover") && <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy Cover<span className='text-danger'>*</span>
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "policy_cover" } });
                    }}
                    name='policy_cover'
                    ref={policyCoverRef}
                    data={coverData ? coverData : []}
                    value={values?.policy_cover}
                    onChange={(selectedOption) =>
                      setFieldValue("policy_cover", selectedOption?.value)
                    }
                  />
                  {errors?.policy_cover &&
                    touched?.policy_cover &&
                    !values?.policy_cover && (
                      <p className='mb-0 text-danger'>
                        {errors?.policy_cover + "*"}
                      </p>
                    )}
                </div>
              </div>}
              {(values.claim_category === "savings_claim" && values.policy_category_id === '2') && <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Claims Type <span className='text-danger'>*</span>
                  </label>
                </div>
                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "claim_type" } });
                    }}
                    name='claim_type'
                    data={claimsTypeData}
                    value={values?.claim_type}
                    onChange={(selectedOption) =>
                      setFieldValue("claim_type", selectedOption?.value)
                    }
                  />
                  {errors?.claim_type &&
                    touched?.claim_type &&
                    !values?.claim_type && (
                      <p className='mb-0 text-danger'>
                        {errors?.claim_type + "*"}
                      </p>
                    )}
                </div>
              </div>}
              {hasCustomForm && <div className='row'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'></div>
                <div className='col-md-7 col-lg-6 text-end'>
                  <span className='dropdown-item notify-item text-primary cursor-p d-inline-block' data-bs-toggle='modal' data-bs-target='#staticBackdrop10'>
                    <i className='mdi mdi-plus'></i>Add New Form?
                  </span>
                </div>
              </div>}
              <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label`}>
                    Form
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "form_id" } });
                    }}
                    name='form_id'
                    data={formData}
                    value={values?.form_id}
                    onChange={(selectedOption) =>
                      setFieldValue("form_id", selectedOption?.value)
                    }
                  />
                  {errors?.form_id && touched?.form_id && !values?.form_id && (
                    <p className='mb-0 text-danger'>{errors?.form_id + "*"}</p>
                  )}
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Workflow<span className='text-danger'>*</span>
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  <Select
                    onBlur={() => {
                      handleBlur({ target: { name: "workflow_id" } });
                    }}
                    name='workflow_id'
                    data={workflowData}
                    value={values?.workflow_id}
                    onChange={(selectedOption) =>
                      setFieldValue("workflow_id", selectedOption?.value)
                    }
                  />
                  {errors?.workflow_id &&
                    touched?.workflow_id &&
                    !values?.workflow_id && (
                      <p className='mb-0 text-danger'>
                        {errors?.workflow_id + "*"}
                      </p>
                    )}
                </div>
              </div>
              {targetRole && (
                <div className='row mb-2'>
                  <div className='col-md-3 col-lg-2'></div>
                  <div className='col-md-7 col-lg-6'>
                    <div className='d-flex d-col flex-wrap'>
                      {JSON.parse(targetRole)?.map((item, index) => (
                        <div
                          className='d-flex d-col align-items-center'
                          key={index + "inner"}
                        >
                          <span
                            className='py-1 px-2 bg-info text-white'
                            style={{ marginTop: "2px" }}
                          >
                            {item.role_name}
                          </span>
                          {JSON.parse(targetRole)?.length !== index + 1 && (
                            <BsArrowRight className='m-0 md-rotate-90' />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              <div className='row mb-3 mt-3'>
                <div className='col-md-3 col-lg-2'></div>
                <div className='col-md-7 col-lg-6'>
                  <button
                    type='submit'
                    className='btn btn-primary btn-sm px-4 rounded'
                  >
                    <span>Create</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <AddCustomForm modal_id='staticBackdrop10' />
    </div>
  );
};

export default AddConfiguration;
